import localDB from "./localDB";
let GLOBAL = require('./globals');

const WebSiteData = {
    async get(res) {
        await fetch(`${GLOBAL.BASE_URL}api/website`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/website`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    }
};

export default WebSiteData;


// WEBPACK FOOTER //
// ./src/data/WebSiteData.js